export class Customer {
  public id: string;
  public customerID: number;
  public firstName: string;
  public middleName: string;
  public lastName: string;
  public mainAddress: string;
  public mailingAddress: string;
  public forgotPasswordToken: string;
  public otherAddress: string;
  public nameSuffix: string;
  public company: string;
  public customerTypeID: number;
  public customerStatusID: number;
  public defaultWarehouseID: number;
  public languageID: string;
  public coverImagePath: string;
  public createdDate: Date;
  public birthDate: any;
  public canLogin: boolean;
  public email: string;
  public gender: boolean;
  public roleName: string;
  public primaryPhone: string;
  public secondaryPhone: string;
  public mobilePhone: string;
  public loginName: string;
  public password: string;
  public field1: string;
  public field2: string;
  public field3: string;
  public field4: string;
  public field5: string;
  public webAlias: string;
  public isActive: string;
  public fullName: string;
  public avatarUrl: string;
  public profileImagePath: string;
  public mainCityId: string;
  public mailingCity: string;
  public otherCity: string;
  public mainCountryID: string;
  public mailingCountryID: string;
  public otherCountryID: string;
  public mainStateID: string;
  public mailingStateID: string;
  public otherStateID: string;
  public mainZipCode: string;
  public mailingZipCode: string;
  public otherZipCode: string;
  public paymentMethodID: number;
  public isCustomer: boolean;
  public mailingCityId: string;
  public shopeName: string;

  public ntnNumber: string; 
  public cnicNumber: string;
  public contactPersonName: string  
  public contactPersonNumber: string  

  public customerStatusName: string ;
  //For bulk CheckUnCheck
  public isCheck: boolean;
  public shopTitle: string;

    public accountTitle: string;
    public accountNumber: string;
    public branchCode: string;
    public branchCity: string;
  public bankName: string;

  public countryCode: string;
  public totalRecords: number;
}
export class CustomerProfiling {

  public customerID: number;
  public visitorID: string;
  public value: string;
  public customerName: string;
  public totalRecords: number;
  public createdDate: Date;
  
}
export class VendorDropDown {
  public shopeName: string;
  public customerID: number;
  public fullName: string;
}





// WEBPACK FOOTER //
// ./src/app/models/customer/customer-model.ts